<div class="container-not-found">
    <app-header class="header"></app-header>
    <div class="container">
        <div class="oops">
            <h1>Opps...</h1>
            <p>Parece que la página que buscas no existe.</p>
            <img (click)="goToUrl()" src="./assets/not-found/button.svg" alt="">
        </div>
        <img class="not" src="./assets/not-found/not-found.svg" alt="">
    </div>
    <app-footer class="footer" [colorItems]="'#ffffff'" [classSpecial]="true"></app-footer>
</div>